const askDoctorKey = (variant) => `sema_glp_ask_doctor__${variant || ''}`
const skipAddressKey = (variant) => `sema_glp_skip_address__${variant || ''}`
const stepKey = (variant) => `sema_glp_onboarding_step__${variant || ''}`

export function getSemaAskDoctorPersisted(variant) {
  try {
    if (typeof window === 'undefined') return false
    return window.localStorage.getItem(askDoctorKey(variant)) === '1'
  } catch {
    return false
  }
}

export function setSemaAskDoctorPersisted(variant) {
  try {
    if (typeof window === 'undefined' || !variant) return
    window.localStorage.setItem(askDoctorKey(variant), '1')
  } catch {
    // no-op
  }
}

/**
 * Whether to skip the address step. Persisted for the same reason as askDoctor: the
 * `?data=` param carrying it is lost if the app is killed and reopened mid-flow, and a
 * patient who already has an address on file (a renewal) must not be asked for it again
 * just because they backgrounded the app.
 *
 * Stored as an explicit skip rather than an "ask" so the absence of a value keeps today's
 * behaviour — address is asked unless the backend says otherwise.
 */
export function getSemaSkipAddressPersisted(variant) {
  try {
    if (typeof window === 'undefined') return false
    return window.localStorage.getItem(skipAddressKey(variant)) === '1'
  } catch {
    return false
  }
}

export function setSemaSkipAddressPersisted(variant) {
  try {
    if (typeof window === 'undefined' || !variant) return
    window.localStorage.setItem(skipAddressKey(variant), '1')
  } catch {
    // no-op
  }
}

export function getSemaOnboardingStepPersisted(variant) {
  try {
    if (typeof window === 'undefined' || !variant) return 0
    const raw = window.localStorage.getItem(stepKey(variant))
    const n = parseInt(raw, 10)
    if (Number.isNaN(n) || n < 0) return 0
    return n
  } catch {
    return 0
  }
}

export function setSemaOnboardingStepPersisted(variant, index) {
  try {
    if (typeof window === 'undefined' || !variant) return
    if (index == null) {
      window.localStorage.removeItem(stepKey(variant))
    } else {
      window.localStorage.setItem(stepKey(variant), String(index))
    }
  } catch {
    // no-op
  }
}

export function clearSemaOnboardingPersisted(variant) {
  try {
    if (typeof window === 'undefined' || !variant) return
    window.localStorage.removeItem(askDoctorKey(variant))
    window.localStorage.removeItem(skipAddressKey(variant))
    window.localStorage.removeItem(stepKey(variant))
  } catch {
    // no-op
  }
}
